import { css } from '@emotion/css';

export const inputCx = css`
  .MuiFormLabel-root.Mui-error {
    color: rgba(0, 0, 0, 0.6);
  }
`;
